export const VIEWED_TIMEOUT = 1000;
